import { makeActionCreator } from '../../configs/store/utils'

export const CLOSE_FEEDBACK_ERROR_DIALOG = 'CLOSE_FEEDBACK_ERROR_DIALOG'
export const onCloseFeedbackErrorDialog = makeActionCreator(CLOSE_FEEDBACK_ERROR_DIALOG)

export const SHOW_FEEDBACK_ERROR_DIALOG = 'SHOW_FEEDBACK_ERROR_DIALOG'
export const onShowFeedbackErrorDialog = makeActionCreator(SHOW_FEEDBACK_ERROR_DIALOG)
